import $ from 'jquery';

/**
 * High contrast
 */
export default class HighContrast {
    /**
     * @param $form High contrast form
     * @param options Additional options
     */
    constructor($form, options = {}) {
        this.options = $.extend(true, {
            classes: {
                toggle: 'high-contrast__toggle',
                contrast: 'high-contrast__item--contrast',
                increase: 'high-contrast__item--increase',
                decrease: 'high-contrast__item--decrease',
                items: 'high-contrast__items',
                visible: 'high-contrast__items--visible',
                setContrast: 'high-contrast-on',
            },
        }, options);

        if (!$form) {
            return;
        }

        this.$form = $form;
        this.$toggle = this.$form.querySelector('.' + this.options.classes.toggle);
        this.$contrast = this.$form.querySelector('.' + this.options.classes.contrast);
        this.$increase = this.$form.querySelector('.' + this.options.classes.increase);
        this.$decrease = this.$form.querySelector('.' + this.options.classes.decrease);
        this.$items = this.$form.querySelector('.' + this.options.classes.items);

        this.init();
    }

    init() {
        this.eventHandlers();

        let contrast = localStorage.getItem('contrast');
        let fontSize = localStorage.getItem('fontsize') || 2; //sizes 0-4 where 2 is default

        if (contrast) this.changeContrast(contrast);
        this.setFontSize(fontSize);
    }

    toggleOptionsList() {
        this.$items.classList.toggle(this.options.classes.visible);
    }

    changeContrast() {
        document.body.classList.toggle(this.options.classes.setContrast);
        if (document.body.classList.contains(this.options.classes.setContrast)) {
            localStorage.setItem('contrast', 'true');
        } else {
            localStorage.removeItem('contrast');
        }
    }

    increaseFontSize() {
        let size = parseInt(localStorage.getItem('fontsize'));
        size = size >= 4 ? size : size + 1;
        this.setFontSize(size);
    }

    decreaseFontSize() {
        let size = parseInt(localStorage.getItem('fontsize'));
        size = size <= 0 ? size : size - 1;
        this.setFontSize(size);
    }

    setFontSize(size) {
        document.documentElement.className.split(' ').forEach(c => {
            if (c.startsWith('font-size')) document.documentElement.classList.remove(c);
        })
        document.documentElement.classList.add('font-size-' + size);
        localStorage.setItem('fontsize', size);

        if(size === 4) {
            this.$increase.setAttribute('disabled', true);
        } else if(size === 0) {
            this.$decrease.setAttribute('disabled', true);
        } else {
            this.$increase.removeAttribute('disabled');
            this.$decrease.removeAttribute('disabled');
        }
    }

    eventHandlers() {
        const handlerToggle = (e) => {
            this.toggleOptionsList();
        }

        const handlerContrast = (e) => {
            this.changeContrast();
        }

        const handlerIncrease = (e) => {
            this.increaseFontSize();
        }

        const handlerDecrease = (e) => {
            this.decreaseFontSize();
        }

        this.$toggle.addEventListener('click', handlerToggle);
        this.$contrast.addEventListener('click', handlerContrast);
        this.$increase.addEventListener('click', handlerIncrease);
        this.$decrease.addEventListener('click', handlerDecrease);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/high-contrast.js